import { use } from 'react'
import Input from '@talkdesk/cobalt-react-input'
import Button from '@talkdesk/cobalt-react-button'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import MFAHeader from '../../components/MFAHeader'
import ErrorMessage from '../../components/ErrorMessage'
import useMFA from '../../hooks/useMFA'
import { LoginContext } from '../../contexts/Login'
import { useTranslation } from 'react-i18next'
import { RECOVERY_OTP } from '../../constants/mfa.types'

export const RecoveryOTP = ({ csrf, ctx }) => {
  const { t } = useTranslation()
  const {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin,
  } = useMFA({
    invalidCodeErrorMessage: () => t('recoveryCode.invalidError'),
    genericErrorMessage: () => t('recoveryCode.genericError'),
  })

  const handleSubmit = () => {
    const mfa = {
      type: RECOVERY_OTP,
      payload: {
        otp: code,
      },
    }
    doLogin(csrf, ctx.credentials, mfa)
  }

  return (
    <>
      <MFAHeader
        icon='vpn_key'
        iconColor='orange600'
        title={t('recoveryCode.title')}
        subtitle={t('recoveryCode.description')}
      />
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        {showError ? <ErrorMessage message={errorMessage} /> : null}
        <div>
          <Label htmlFor='recovery-code'>{t('recoveryCode.title')}</Label>
          <Box paddingTop={2} />
          <Input
            id='recovery-code'
            autoFocus
            value={code}
            onChange={handleCodeChange}
            placeholder={t('recoveryCode.title')}
            type='text'
            inputMode='numeric'
            pattern='[0-9]*'
            disabled={disabledForm}
          />
        </div>
        <Box paddingTop={4} />
        <Button
          htmlType='submit'
          disabled={isVerifyButtonDisabled()}
          state={verifyButtonState}
          type='primary'
          shape='full-width'
        >
          {t('mfa.verify')}
        </Button>
      </form>
    </>
  )
}

const RecoveryOTPWithContext = (props) => {
  const ctx = use(LoginContext)
  return <RecoveryOTP ctx={ctx} {...props} />
}
RecoveryOTPWithContext.displayName = 'RecoveryOTP'

export default RecoveryOTPWithContext
